import styled from 'styled-components';
import { ModalCard, ModalContent } from '@clds/modal';
import { theme } from './ModalTheme';

export const StyledModalCard = styled(ModalCard)`
  max-width: ${theme.content.maxWidth};
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const StyledModalContent = styled(ModalContent)`
  > p {
    :first-of-type {
      margin-top: 0;
    }

    :last-of-type {
      margin-bottom: 0;
    }
  }
`;
